import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID, ViewEncapsulation, } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd, } from '@angular/router';
import { AppService } from './app.service';
import { DOCUMENT, DatePipe, isPlatformBrowser } from '@angular/common';
import AOS from 'aos';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [DatePipe],
})

export class AppComponent implements OnInit, OnDestroy {

  runBy: any = 0;
  // upComingVisits;
  upComingVisits$;

  constructor(
    public Router: Router,
    private translate: TranslateService,
    public app: AppService,
    private datePipe: DatePipe,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private document: Document,
    private title: Title,
    private route: ActivatedRoute,
  ) {
    if (window?.location?.pathname.includes('/ar/')) {
      this.translate.use('ar');
      document.dir = 'rtl';
      localStorage.setItem('Direction', 'rtl');
      this.app.languageCode = 'ar'
      localStorage.setItem("Language", 'ar');
    } else if (window?.location?.pathname.includes('/en/')) {
      this.translate.use('en');
      document.dir = 'ltr';
      localStorage.setItem('Direction', 'ltr');
      this.app.languageCode = 'en'
      localStorage.setItem("Language", 'en');
    } else {
      if (!this.app.getUserDire()) {
        this.translate.use('ar');
        localStorage.setItem('Direction', 'rtl');
        document.dir = 'rtl';
        this.app.languageCode = 'ar'
        localStorage.setItem("Language", 'ar');
      } else {
        this.translate.use(this?.app?.getUserLanguage());
        document.dir = this!.app!.getUserDire();
      }
    }
    // if (isPlatformBrowser(this.platformId)) {
    //   if (!this.app.getUserDire()) {
    //     this.Router.events.subscribe((e) => {
    //       if (e instanceof NavigationEnd) {
    //         if (e?.url?.includes('/ar/')) {
    //           localStorage.setItem("Direction", 'rtl');
    //           document.dir = 'rtl'
    //         } else if (e?.url?.includes('/en/')) {
    //           localStorage.setItem("Direction", 'ltr');
    //           document.dir = 'ltr'
    //         } else {
    //           localStorage.setItem("Direction", 'rtl');
    //           document.dir = 'rtl'
    //         }
    //       }
    //     })
    //   } else if (this.app.getUserDire()) {
    //     document.dir = this!.app!.getUserDire()
    //   }
    // }
  }

  ngOnInit() {
    // Init Animations on scroll
    AOS.init()
    // Handle Title And Link Element in header Dynamically 
    this.handleTitleAndLink()
    // RoleCheck And If There is Appointments Soon
    this.app.checkRole();
    // to check if there is appointments every 2m & check if doctor is subscribed
    if (isPlatformBrowser(this.platformId)) {
      this.getAppointment();
      this.app.refreshTokenIfDoctorSubChanged();
      this.runBy = setInterval(() => {
        this.app.refreshTokenIfDoctorSubChanged();
        this.getAppointment();
      }, 300000);
    }
  }

  ngOnDestroy() {
    if (this.runBy) {
      clearInterval(this.runBy);
    }
  }



  // handle small box for video call
  addMinutes(numOfMinutes) {
    let date: any = new Date();
    date.setMinutes(date.getMinutes() + numOfMinutes);
    return date;
  }

  getAppointment() {
    let b = this.addMinutes(-30)
    let before30 = this.datePipe.transform(b, 'yyyy-MM-ddTHH:mm:ss');

    let c = this.addMinutes(15)
    let after30 = this.datePipe.transform(c, 'yyyy-MM-ddTHH:mm:ss');

    // 2022-07-19T06:25:57.763Z
    let req = {
      from: before30,
      to: after30,
      statuses: [4, 7],
      pageSize: 999,
      pageNumber: 1
    }


    if (this.app.isDoctor) {
      this.app.searchVisitsForHcp(req).subscribe(
        res => {
          let g = res.data.data
          let c = g.filter(x => x.service.classification == 2)
          if (this?.app?.checkVisitTimeIfNow(c[0]?.visitDate, c[0]?.endDate)) {
            this.upComingVisits$ = c
          }
        }
      )
    }

    let reqUser = {
      from: before30,
      to: after30,
      statuses: [7],
      pageSize: 999,
      pageNumber: 1
    }

    if (this.app.isPatient) {
      this.app.searchVisitsForUsers(reqUser).subscribe(
        res => {
          let g = res.data.data
          let c = g.filter(x => x.service.classification == 2)
          if (this?.app?.checkVisitTimeIfNow(c[0]?.visitDate, c[0]?.endDate)) {
            this.upComingVisits$ = c
          }
        }
      )
    }

    // this.app.dismissLoading();
  }
  // /handle small box for video call


  // Handle Title through entire routes if title is not provided in component >> check app routing module
  handleTitleAndLink() {
    this.Router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        let langServerSideCode = event?.url?.includes('/en/') ? 'en' : 'ar';
        const lang = isPlatformBrowser(this.platformId) ? this?.app?.languageCode : langServerSideCode
        const title = this.getTitle(this.route.root);
        // handle link element changes on header
        this.linkEdit(event?.url)
        if (title['ar'] || title['en']) {
          this.title.setTitle(title[lang] || title['ar']);
        } else {
          // Else doing nothing because if dataTitle not provided in app-routing-modules it will be provided in component(dynamic TITLE)

          // if (lang == 'en') {
          //   this.title.setTitle("iHospital");
          // } else {
          //   this.title.setTitle("iHospital");
          // }
        }
      }
    });
  }

  linkEdit(url) {
    let decodedUrl = decodeURIComponent(url);
    let linkEn = this.document.getElementById("linkSightEn")
    let linkAr = this.document.getElementById("linkSightAr")
    linkEn.setAttribute('href', `https://www.ihospitalapp.com/en/${decodedUrl.slice(4, decodedUrl.length)}`);
    linkAr.setAttribute('href', `https://www.ihospitalapp.com/ar/${decodedUrl.slice(4, decodedUrl.length)}`);
  }

  getTitle(route: ActivatedRoute): any {
    const title = route.snapshot.data['title'];
    if (route.firstChild) {
      return { ...title, ...this.getTitle(route.firstChild) };
    } else {
      return title;
    }
  }
}

